import type { PlotPieOptions } from "highcharts";
export interface PieChartConfigArgs {
	size?: number;
	data: number[];
	colors: string[];
	innerSize?: number;
	width?: number;
	height?: number;
	plotOptions?: PlotPieOptions;
}
export default function createPieChartConfig({
	width,
	height,
	colors,
	data,
	innerSize = 0,
	plotOptions,
	size = 130,
}: PieChartConfigArgs) {
	return {
		title: {
			text: undefined,
		},
		tooltip: {
			enabled: false,
		},
		plotOptions: {
			pie: {
				size,
				innerSize: `${innerSize}%`,
				colors: colors,
				allowPointSelect: false,
				dataLabels: { enabled: false },
				borderRadius: 0,
				borderWidth: 0,
				...plotOptions,
			},
		},
		chart: {
			backgroundColor: "transparent",
			spacing: [0, 0, 0, 0],
			animation: false,
			width,
			height,
		},
		legend: { enabled: false },
		credits: { enabled: false },
		series: [
			{
				type: "pie",
				data,
			},
		],
		accessibility: { enabled: false },
	} satisfies Highcharts.Options;
}
